// Partial save of Beta #1 of the loading screen: each order's progress on
// this device, so a reload, a back or a dropped connection keeps the load.
// Every function swallows storage errors (private mode, full storage).

const PREFIX = 'cargaBeta:v1:';
const MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000;

const keyFor = (poNumber) => `${PREFIX}${poNumber}`;

// The saved load of an order ({ savedAt, scans, order }), or null.
export const loadSavedLoad = (poNumber) => {
  try {
    const raw = window.localStorage.getItem(keyFor(poNumber));
    if (!raw) return null;
    const saved = JSON.parse(raw);
    return saved && Array.isArray(saved.scans) ? saved : null;
  } catch (err) {
    return null;
  }
};

// Returns whether the device stored it.
export const saveLoad = (poNumber, { scans, order }, now = new Date()) => {
  try {
    window.localStorage.setItem(
      keyFor(poNumber),
      JSON.stringify({ savedAt: now.toISOString(), scans, order }),
    );
    return true;
  } catch (err) {
    return false;
  }
};

export const clearSavedLoad = (poNumber) => {
  try {
    window.localStorage.removeItem(keyFor(poNumber));
  } catch (err) {
    // Nothing stored, nothing to clear.
  }
};

// Drops saved loads older than three days, and entries that can't be read.
export const pruneSavedLoads = (now = new Date()) => {
  try {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(PREFIX)) keys.push(key);
    }
    keys.forEach((key) => {
      let savedAt = NaN;
      try {
        savedAt = Date.parse(JSON.parse(window.localStorage.getItem(key)).savedAt);
      } catch (err) {
        // Unreadable: dropped below.
      }
      if (!(now.getTime() - savedAt <= MAX_AGE_MS)) window.localStorage.removeItem(key);
    });
  } catch (err) {
    // Storage unavailable.
  }
};

// Saved scans back onto the order's current lines. Scans of SKUs that left
// the order are dropped.
export const restoreScans = (items, scans) => (scans || [])
  .map((scan) => {
    const item = (items || []).find((line) => line.sku_code === scan.sku_code);
    return item ? { ...item, scanned_quantity: Number(scan.scanned_quantity) } : null;
  })
  .filter(Boolean);
